// Formata número para moeda brasileira: 5000 → R$ 5.000,00
export function formatarMoeda(valor) {
  if (valor === null || valor === undefined) return '';
  const numero = Number(valor);
  return numero.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });
}

// Converte valor formatado para número: R$ 5.000,00 → 5000.00
export function desformatarMoeda(valor) {
  if (!valor) return '';
  return valor.replace(/\D/g, '') / 100;
}